<template>
    <b-form>
        <b-form-group
            horizontal
            label="Role"
            label-for="role"
            label-cols="0"
            label-cols-sm="2"
            label-align-sm="right"
        >
            <b-form-select
                id="role"
                v-model="roleToAdd.roleId"
                name="role"
                :options="availableRoles"
                text-field="name"
                value-field="roleId"
                @change="emitUpdate"
            />
        </b-form-group>

        <template v-if="roleNeedsApplicantId">
            <b-form-group
                horizontal
                label="Add Institution"
                label-for="ee_list"
                label-cols="0"
                label-cols-sm="2"
                label-align-sm="right"
            >
                <b-form-select
                    id="ee_list"
                    v-model="eeCode"
                    name="ee_list"
                    :options="eeCodeOptions"
                    @change="emitUpdate"
                >
                    <template #first>
                        <b-select-option :value="null">
                            -- Please select an option --
                        </b-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
        </template>
    </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { Arc } from '$Shared/@arc/vue-arc';

export default {
    props: {
        role: { type: Object, default: null },
    },

    data() {
        return {
            rolesRequiringApplicantId: ['AP', 'RO'],
            eeCode: null,
            roleToAdd: {
                realmId: null,
                roleId: null,
                oaId: null,
                applicantId: null,
            },
        };
    },

    computed: {
        ...mapGetters({
            activeRealm: 'auth/activeRealm',
            realmRoles: 'ref/admin/realmRoles',
            refFice: 'ref/ee/refFice',
            realmApplicants: 'ref/global/realmApplicants',
        }),

        availableRoles() {
            return this.realmRoles.map((role) => {
                return {
                    ...role,
                    name: role.name + ' (' + role.roleId + ')'
                };
            });
        },

        roleNeedsApplicantId() {
            return this.rolesRequiringApplicantId.includes(this.roleToAdd.roleId);
        },

        eeCodeOptions() {
            return Arc.options.makeSortedSelectFromLookup(this.refFice);
        },
    },

    watch: {
        'roleToAdd.roleId'() {
            this.roleToAdd.oaId = null;
            this.roleToAdd.applicantId = null;
            this.eeCode = null;
        },

        eeCode() {
            this.roleToAdd.applicantId = this.eeCode;
        },
    },

    created() {
        this.roleToAdd = this.role || this.roleToAdd;
        this.roleToAdd.realmId = this.activeRealm;
    },

    methods: {
        emitUpdate() {
            this.$emit('update:role', this.roleToAdd);
        },
    },
};
</script>
